export const getDailyCreditUsageMockResponse = [
    {
        instanceId: '133612',
        cloudName: 'prestagingptf3.drtst.org',
        dailyCreditStats: new Array(90).fill(0).map((_, i) => ({
            day: 20149,
            creditsConsumed: `${4.40900000099 * i}`,
            savings: [],
            consumption: [
                {
                    serviceKey: 'NON_LTR',
                    amount: 0,
                },
                {
                    serviceKey: 'EARLY_DELETE',
                    amount: 0,
                },
            ],
        })),
    },
];
